import axios from 'axios'

const token = sessionStorage.getItem('accessToken')
export default axios.create({
  // baseURL: 'http://localhost:3000/api/admin/',
  baseURL: 'https://api.interbon.bg/api/admin/',
  headers: {
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json'
  }
})
